module.exports = __webpack_public_path__ + "static/media/TN.c17b985c.svg";